import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import {CompanyService} from "./company.service";

@Injectable()
export class CompanyIdInterceptor implements HttpInterceptor {

  constructor(private companyService: CompanyService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const company = this.companyService.getSelectedCompany();
    if (company) {
      req = req.clone({
        setHeaders: {
          'X-cid': company.id
        }
      });
    }
    return next.handle(req);
  }
}
